import { httpClient } from '@/api/http-client'
import { DependentPayload } from '@/types'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type CreateDependentParams = {
  companyKey: string
  partnerKey: string
  dependentData: DependentPayload
}

export const createDependent = async ({
  companyKey,
  partnerKey,
  dependentData,
}: CreateDependentParams) => {
  const response = await httpClient('accounting-dealer').post<DependentPayload>(
    `/v3/company/${companyKey}/partner/${partnerKey}/dependent`,
    dependentData,
  )
  return response.data
}

export const useCreateDependent = (
  options?: UseMutationOptions<
    DependentPayload,
    AxiosError,
    CreateDependentParams
  >,
) => {
  return useMutation({
    mutationFn: createDependent,
    ...options,
  })
}
